module.exports = __webpack_public_path__ + "static/blumenstecker-pinguin.012610a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fulls/blumenstecker-pinguin.jpg
// module id = 546
// module chunks = 35783957827783